
const TokenKey = 'jyj-admin-Token'

const TokenExpireTime = 'jyj-admin-TokenExpireTime'

const LastOperationTime = 'jyj-admin-LastOperationTime'


export function getToken() {
  return localStorage.getItem(TokenKey) 
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

export function getLastOperationTime() {
  return localStorage.getItem(LastOperationTime) 
}

export function setLastOperationTime(time) {
  return localStorage.setItem(LastOperationTime, time)
}

export function getTokenExpireTime() {
  return localStorage.getItem(TokenExpireTime) 
}

export function setTokenExpireTime(time) {
  return localStorage.setItem(TokenExpireTime, time)
}


